import { IconButton, InputAdornment, TextField } from '@hiiretail/react-foundation-ui';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { ChangeEvent, FC, MouseEvent, useRef } from 'react';
import { useIntl } from 'react-intl';

interface ItemsSearchInputProps {
  value: string;
  onFocus: () => void;
  onChangeText: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onClear: () => void;
  onSearch: () => void;
}

export const ItemsSearchInput: FC<ItemsSearchInputProps> = ({
  value,
  onFocus,
  onChangeText,
  onClear,
  onSearch,
}) => {
  const intl = useIntl();

  const inputRef = useRef<HTMLInputElement>(null);
  const displayClearButton = !!value && onClear;
  const displayItemSearchButton = !!value && onSearch;

  const clear = () => {
    onClear();
    inputRef.current?.focus();
  };

  const handleKeepInputFocus = (event: MouseEvent) => {
    event.preventDefault();
  };

  return (
    <TextField
      ref={inputRef}
      data-testid="item-search-query"
      name="item-search-query"
      autoFocus
      spellCheck="false"
      onFocus={onFocus}
      sx={{ width: 'inherit' }}
      label={intl.formatMessage({ id: 'items.search.autcomplete.label' })}
      value={value}
      onChange={onChangeText}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {displayClearButton && (
              <IconButton
                aria-label="clear input"
                onMouseDown={handleKeepInputFocus}
                onClick={clear}
                size="small"
                edge="end"
                placeholder={intl.formatMessage({ id: 'items.search.autcomplete.clear' })}
                title={intl.formatMessage({ id: 'items.search.autcomplete.clear' })}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            )}
            {displayItemSearchButton && (
              <IconButton
                size="small"
                onClick={onSearch}
                placeholder={intl.formatMessage({ id: 'items.search.autcomplete.search' })}
                title={intl.formatMessage({ id: 'items.search.autcomplete.search' })}
              >
                <SearchIcon />
              </IconButton>
            )}
          </InputAdornment>
        ),
      }}
    />
  );
};
